import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService, bProfile, useProfile } from "@brg/auth";
import { AppTester } from "../../../../supporting";
import { useMemo } from "react";
import {LinkTo} from "../../../constants/linkTo";

interface MediaContextLink {
    id: ContextCodes;
    active: boolean;
    content: string;
    linkTo: string;
    action: () => void;
    target: string;
    level: number | string;
    hasChildren: boolean;
    hasCornerArrow: boolean;
    hidden: boolean;
    externalLink: boolean;
}

export const useGetMediaContexts = () => {
  const { isMediiia } = useAppTester();
  const { pathname } = useLocation();
  const profile = useProfile();

  const isModer = useMemo(
    () => profile && (bProfile.isModer(profile) || bProfile.isJuniorModer(profile)), [profile])

  const isMediaCtxs = AppTester.isContext('creativemediiia') ||
    AppTester.isContext('historymediiia') ||
    AppTester.isContext('profmediiia') ||
    AppTester.isContext('gamemediiia') ||
    AppTester.isContext('photomediiia') ||
    AppTester.isContext('cinemediiia') ||
    AppTester.isContext('aimediiia') ||
    AppTester.isContext('sportmediiia') ||
    AppTester.isContext('eventmediiia') ||
    AppTester.isContext('transfermediiia') ||
    AppTester.isContext('musicmediiia') ||
    AppTester.isContext('storiesmediiia') ||
    AppTester.isContext('artmediiia') ||
    AppTester.isContext('automediiia') ||
    AppTester.isContext('designmediiia') ||
    AppTester.isContext('urbanmediiia') ||
    AppTester.isContext('fashionmediiia') ||
    AppTester.isContext('foodmediiia') ||
    AppTester.isContext('automediiia') ||
    AppTester.isContext('booksmediiia') ||
    AppTester.isContext('lmsmediiia') ||
    AppTester.isContext('naturemediiia') ||
    AppTester.isContext('conceptmediiia') 

  const isLectureMediiia = AppTester.isLectureMediiia();

  const isMediiiaMain = isMediiia && !isMediaCtxs

  const {
    REACT_APP_URL_MEDIIIA_COM,
    REACT_APP_URL_MEDIIIA_RU,
    REACT_APP_URL_EDUCATION_MEDIIIA_COM,
    REACT_APP_URL_EDUCATION_MEDIIIA_RU,
  } = process.env;
  const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
  const baseURL = window.location.origin.includes("com") ? REACT_APP_URL_MEDIIIA_COM : REACT_APP_URL_MEDIIIA_RU;
  const educationUrl = window.location.origin.includes("com") ? REACT_APP_URL_EDUCATION_MEDIIIA_COM : REACT_APP_URL_EDUCATION_MEDIIIA_RU;
  const history = useHistory()

  const links = useMemo(() => {
    const links: MediaContextLink[] = [
    {
      id: ContextCodes.hseDesignMain,
      active: (['/', '/portfolio'].includes(pathname) && isMediiiaMain),
      content: 'main',
      linkTo: '/',
      action: () => {
        if (isMediiiaMain) {
          history.push('/')
          return;
        }
        window.open(baseURL + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('artmediiia'),
      content: 'art',
      linkTo: `${baseURL}/art`,
      action: () => {
        window.open(baseURL + '/art' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('storiesmediiia'),
      content: 'stories',
      linkTo: `${baseURL}/stories`,
      action: () => {

        window.open(baseURL + '/stories' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('historymediiia'),
      content: 'history',
      linkTo: `${baseURL}/history`,
      action: () => {
        window.open(baseURL + '/history' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('sportmediiia'),
      content: 'sport',
      linkTo: `${baseURL}/sport`,
      action: () => {
        window.open(baseURL + '/sport' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('eventmediiia'),
      content: '365',
      linkTo: `${baseURL}/365`,
      action: () => {
        window.open(baseURL + '/365' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('naturemediiia'),
      content: 'astro',
      linkTo: `${baseURL}/astro`,
      action: () => {

        window.open(baseURL + '/astro' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('aimediiia'),
      content: 'ai',
      linkTo: `${baseURL}/ai`,
      action: () => {
        window.open(baseURL + '/ai' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('musicmediiia'),
      content: 'sound',
      linkTo: `${baseURL}/sound`,
      action: () => {
        window.open(baseURL + '/sound' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('photomediiia'),
      content: 'photo',
      linkTo: `${baseURL}/photo`,
      action: () => {
        window.open(baseURL + '/photo' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('cinemediiia'),
      content: 'cine',
      linkTo: `${baseURL}/cine`,
      action: () => {
        window.open(baseURL + '/cine' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('foodmediiia'),
      content: 'food',
      linkTo: `${baseURL}/food`,
      action: () => {

        window.open(baseURL + '/food' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('automediiia'),
      content: 'auto',
      linkTo: `${baseURL}/auto`,
      action: () => {
        window.open(baseURL + '/auto' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('profmediiia'),
      content: 'profi',
      linkTo: `${baseURL}/profi`,
      action: () => {
        window.open(baseURL + '/profi' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('designmediiia'),
      content: 'design',
      linkTo: `https://deziiign.com/`,
      action: () => {
        window.open('https://deziiign.com/', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('fashionmediiia'),
      content: 'fashion',
      linkTo: `https://fashion.deziiign.com/`,
      action: () => {
        window.open('https://fashion.deziiign.com/', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('urbanmediiia'),
      content: 'urban',
      linkTo: `https://urban.deziiign.com/`,
      action: () => {
        window.open('https://urban.deziiign.com/', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: false,
      content: 'creativecity',
      linkTo: process.env.REACT_APP_URL_CREATIVE_CITY,
      action: () => {
        window.open(process.env.REACT_APP_URL_CREATIVE_CITY, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('gamemediiia'),
      content: 'game',
      linkTo: `https://game.deziiign.com/`,
      action: () => {
        window.open('https://game.deziiign.com/', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('brndmediiia'),
      content: 'brnd',
      linkTo: 'https://shop.brnd.ru/?page=1 ',
      action: () => {
        window.open('https://shop.brnd.ru/?page=1', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('booksmediiia'),
      content: 'books',
      linkTo: process.env.REACT_APP_URL_BOOKS_GALLLLERY || '',
      action: () => {
        window.open(process.env.REACT_APP_URL_BOOKS_GALLLLERY, "_self")
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isGalllleryArt(),
      content: 'gallllery',
      linkTo: process.env.REACT_APP_URL_DEZIIIGN_GALLERY_ART,
      action: () => {
        window.open(process.env.REACT_APP_URL_DEZIIIGN_GALLERY_ART, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isKiiidsArt(),
      content: 'kiiids',
      linkTo: process.env.REACT_APP_URL_KIIIDS_ART,
      action: () => {
        window.open(process.env.REACT_APP_URL_KIIIDS_ART, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: isLectureMediiia,
      content: 'education',
      linkTo: `${educationUrl || ''}`,
      action: () => {
        window.open(educationUrl + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('conceptmediiia'),
      content: 'concept',
      linkTo: `${baseURL}/concept`,
      action: () => {

        window.open(baseURL + '/concept' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
  ].filter(({ hidden }) => !hidden)
  return links
  }, [
    REACT_APP_URL_EDUCATION_MEDIIIA_COM,
    REACT_APP_URL_EDUCATION_MEDIIIA_RU,
    REACT_APP_URL_MEDIIIA_COM,
    REACT_APP_URL_MEDIIIA_RU,
    history,
    isLectureMediiia,
    isMediiia,
    isMediiiaMain,
    pathname,
    suffix,
    isModer
  ])

  return {
    links,
    modalSettings: {
      titleColor: '#151514',
      title: 'mediiia'
    }
  }
}import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService, bProfile, useProfile } from "@brg/auth";
import { AppTester } from "../../../../supporting";
import { useMemo } from "react";
import {LinkTo} from "../../../constants/linkTo";

interface MediaContextLink {
    id: ContextCodes;
    active: boolean;
    content: string;
    linkTo: string;
    action: () => void;
    target: string;
    level: number | string;
    hasChildren: boolean;
    hasCornerArrow: boolean;
    hidden: boolean;
    externalLink: boolean;
}

export const useGetMediaContexts = () => {
  const { isMediiia } = useAppTester();
  const { pathname } = useLocation();
  const profile = useProfile();

  const isModer = useMemo(
    () => profile && (bProfile.isModer(profile) || bProfile.isJuniorModer(profile)), [profile])

  const isMediaCtxs = AppTester.isContext('creativemediiia') ||
    AppTester.isContext('historymediiia') ||
    AppTester.isContext('profmediiia') ||
    AppTester.isContext('gamemediiia') ||
    AppTester.isContext('photomediiia') ||
    AppTester.isContext('cinemediiia') ||
    AppTester.isContext('aimediiia') ||
    AppTester.isContext('sportmediiia') ||
    AppTester.isContext('eventmediiia') ||
    AppTester.isContext('transfermediiia') ||
    AppTester.isContext('musicmediiia') ||
    AppTester.isContext('storiesmediiia') ||
    AppTester.isContext('artmediiia') ||
    AppTester.isContext('automediiia') ||
    AppTester.isContext('designmediiia') ||
    AppTester.isContext('urbanmediiia') ||
    AppTester.isContext('fashionmediiia') ||
    AppTester.isContext('foodmediiia') ||
    AppTester.isContext('automediiia') ||
    AppTester.isContext('booksmediiia') ||
    AppTester.isContext('lmsmediiia') ||
    AppTester.isContext('naturemediiia') ||
    AppTester.isContext('conceptmediiia') 

  const isLectureMediiia = AppTester.isLectureMediiia();

  const isMediiiaMain = isMediiia && !isMediaCtxs

  const {
    REACT_APP_URL_MEDIIIA_COM,
    REACT_APP_URL_MEDIIIA_RU,
    REACT_APP_URL_EDUCATION_MEDIIIA_COM,
    REACT_APP_URL_EDUCATION_MEDIIIA_RU,
  } = process.env;
  const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
  const baseURL = window.location.origin.includes("com") ? REACT_APP_URL_MEDIIIA_COM : REACT_APP_URL_MEDIIIA_RU;
  const educationUrl = window.location.origin.includes("com") ? REACT_APP_URL_EDUCATION_MEDIIIA_COM : REACT_APP_URL_EDUCATION_MEDIIIA_RU;
  const history = useHistory()

  const links = useMemo(() => {
    const links: MediaContextLink[] = [
    {
      id: ContextCodes.hseDesignMain,
      active: (['/', '/portfolio'].includes(pathname) && isMediiiaMain),
      content: 'main',
      linkTo: '/',
      action: () => {
        if (isMediiiaMain) {
          history.push('/')
          return;
        }
        window.open(baseURL + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('artmediiia'),
      content: 'art',
      linkTo: `${baseURL}/art`,
      action: () => {
        window.open(baseURL + '/art' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('storiesmediiia'),
      content: 'stories',
      linkTo: `${baseURL}/stories`,
      action: () => {

        window.open(baseURL + '/stories' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('historymediiia'),
      content: 'history',
      linkTo: `${baseURL}/history`,
      action: () => {
        window.open(baseURL + '/history' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('sportmediiia'),
      content: 'sport',
      linkTo: `${baseURL}/sport`,
      action: () => {
        window.open(baseURL + '/sport' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('eventmediiia'),
      content: '365',
      linkTo: `${baseURL}/365`,
      action: () => {
        window.open(baseURL + '/365' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('naturemediiia'),
      content: 'astro',
      linkTo: `${baseURL}/astro`,
      action: () => {

        window.open(baseURL + '/astro' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('aimediiia'),
      content: 'ai',
      linkTo: `${baseURL}/ai`,
      action: () => {
        window.open(baseURL + '/ai' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('musicmediiia'),
      content: 'sound',
      linkTo: `${baseURL}/sound`,
      action: () => {
        window.open(baseURL + '/sound' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('photomediiia'),
      content: 'photo',
      linkTo: `${baseURL}/photo`,
      action: () => {
        window.open(baseURL + '/photo' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('cinemediiia'),
      content: 'cine',
      linkTo: `${baseURL}/cine`,
      action: () => {
        window.open(baseURL + '/cine' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('foodmediiia'),
      content: 'food',
      linkTo: `${baseURL}/food`,
      action: () => {

        window.open(baseURL + '/food' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('automediiia'),
      content: 'auto',
      linkTo: `${baseURL}/auto`,
      action: () => {
        window.open(baseURL + '/auto' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('profmediiia'),
      content: 'profi',
      linkTo: `${baseURL}/profi`,
      action: () => {
        window.open(baseURL + '/profi' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('designmediiia'),
      content: 'design',
      linkTo: `https://deziiign.com/`,
      action: () => {
        window.open('https://deziiign.com/', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('fashionmediiia'),
      content: 'fashion',
      linkTo: `https://fashion.deziiign.com/`,
      action: () => {
        window.open('https://fashion.deziiign.com/', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('urbanmediiia'),
      content: 'urban',
      linkTo: `https://urban.deziiign.com/`,
      action: () => {
        window.open('https://urban.deziiign.com/', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: false,
      content: 'creativecity',
      linkTo: process.env.REACT_APP_URL_CREATIVE_CITY,
      action: () => {
        window.open(process.env.REACT_APP_URL_CREATIVE_CITY, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('gamemediiia'),
      content: 'game',
      linkTo: `https://game.deziiign.com/`,
      action: () => {
        window.open('https://game.deziiign.com/', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('brndmediiia'),
      content: 'brnd',
      linkTo: 'https://shop.brnd.ru/?page=1 ',
      action: () => {
        window.open('https://shop.brnd.ru/?page=1', '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('booksmediiia'),
      content: 'books',
      linkTo: process.env.REACT_APP_URL_BOOKS_GALLLLERY || '',
      action: () => {
        window.open(process.env.REACT_APP_URL_BOOKS_GALLLLERY, "_self")
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isGalllleryArt(),
      content: 'gallllery',
      linkTo: process.env.REACT_APP_URL_DEZIIIGN_GALLERY_ART,
      action: () => {
        window.open(process.env.REACT_APP_URL_DEZIIIGN_GALLERY_ART, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isKiiidsArt(),
      content: 'kiiids',
      linkTo: process.env.REACT_APP_URL_KIIIDS_ART,
      action: () => {
        window.open(process.env.REACT_APP_URL_KIIIDS_ART, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: isLectureMediiia,
      content: 'education',
      linkTo: `${educationUrl || ''}`,
      action: () => {
        window.open(educationUrl + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: true
    },
    {
      id: ContextCodes.hseVisualResearch,
      active: AppTester.isContext('conceptmediiia'),
      content: 'concept',
      linkTo: `${baseURL}/concept`,
      action: () => {

        window.open(baseURL + '/concept' + suffix, '_self')
      },
      target: '_self',
      level: 1,
      hasChildren: true,
      hasCornerArrow: false,
      hidden: false,
      externalLink: false
    },
  ].filter(({ hidden }) => !hidden)
  return links
  }, [
    REACT_APP_URL_EDUCATION_MEDIIIA_COM,
    REACT_APP_URL_EDUCATION_MEDIIIA_RU,
    REACT_APP_URL_MEDIIIA_COM,
    REACT_APP_URL_MEDIIIA_RU,
    history,
    isLectureMediiia,
    isMediiia,
    isMediiiaMain,
    pathname,
    suffix,
    isModer
  ])

  return {
    links,
    modalSettings: {
      titleColor: '#151514',
      title: 'mediiia'
    }
  }
}